import { useState } from 'react';
import HubLayout from '../../components/hub/HubLayout.jsx';

export default function Domains({ config }) {
  const domains = config.domains || [];
  const weightingMap = config.weightingMap || null;

  const [filter, setFilter] = useState('');
  const [openMap, setOpenMap] = useState(() => {
    const m = {};
    domains.forEach((d, i) => { m[d.id] = i === 0; });
    return m;
  });

  const f = filter.trim().toLowerCase();

  function expandAll() {
    const allOpen = domains.every((d) => openMap[d.id]);
    const next = {};
    domains.forEach((d) => { next[d.id] = !allOpen; });
    setOpenMap(next);
  }

  function matches(d) {
    if (!f) return true;
    if (d.title.toLowerCase().includes(f) || d.id.toLowerCase().includes(f)) return true;
    return d.sections.some((s) =>
      s.heading.toLowerCase().includes(f) ||
      s.items.some((item) => (item.term + ' ' + item.desc).toLowerCase().includes(f))
    );
  }

  const visible = domains.filter(matches);

  return (
    <HubLayout config={config}>
      <section>
        <div className="section-head">
          <h2>Exam Domains</h2>
          <span className="section-tag">{config.code}</span>
        </div>
        <p>Click any domain to expand the breakdown. Use search to filter across objectives. Weighting reflects the percentage of exam questions drawn from each area.</p>

        <div className="toolbar">
          <div className="search">
            <input
              type="text"
              placeholder="Filter objectives, terms, acronyms..."
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
          <button type="button" className="btn-mini" onClick={expandAll}>Expand all</button>
        </div>

        <div className="domain-list">
          {visible.map((d) => (
            <details
              key={d.id}
              className="domain"
              open={!!openMap[d.id]}
              onToggle={(e) => {
                const isOpen = e.currentTarget.open;
                setOpenMap((m) => (m[d.id] === isOpen ? m : { ...m, [d.id]: isOpen }));
              }}
            >
              <summary>
                <span className="domain-id">{d.id}</span>
                <span className="domain-title">{d.title}</span>
                <span className="summary-meta">
                  <span>{d.weight}</span>
                  <span className="weight-bar" style={{ '--w': `${d.weightPct}%` }}></span>
                </span>
              </summary>
              <div className="details-body">
                <p>{d.intro}</p>
                {d.sections.map((s) => (
                  <div key={s.heading}>
                    <h4>{s.heading}</h4>
                    <ul>
                      {s.items.map((item, i) => (
                        <li key={i}>
                          <strong>{item.term}</strong>{item.desc ? ' — ' : ''}{item.desc}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </details>
          ))}
          {visible.length === 0 && <p style={{ opacity: 0.6 }}>No domains match that filter.</p>}
        </div>
      </section>

      {weightingMap && (
        <section>
          <div className="section-head">
            <h2>Weighting Map</h2>
            <span className="section-tag">allocate study time accordingly</span>
          </div>
          <p>Spend study time proportionally to each domain's exam weight.</p>
          <div className="grid grid-3">
            {weightingMap.map((d) => (
              <div key={d.id} className="card">
                <div className="card-num"><span>{d.id}</span><span className="weight">{d.weight}</span></div>
                <h3>{d.title}</h3>
                <p>{d.desc}</p>
              </div>
            ))}
          </div>
        </section>
      )}
    </HubLayout>
  );
}
